/* eslint-disable camelcase */
/* eslint-disable max-len */
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { AvatarComponent } from '../..';
import { FlexContainer } from '../../../globalStyles';
import { getFormatedTimestamp } from '../../../services/utility/moment';
import { ImageContainer } from '../../Common/CommentItem/CommentItem.style';
import { device, fontFamily } from '../../constants';
import { getStringLocale } from '../../../constants/language';

export const Container = styled.div`
  width: 100%;
  position: relative;
  background-color: #eeeff5;
  border-radius: 1rem;
`;

export const UsernameText = styled.div`
  color: #4a4a4a;
  font: 1.6rem ${fontFamily.circularBold};
  &.ml {
    margin-left: 1rem;
  }
`;

export const Content = styled.div`
  color: #404046;
  font: 1.6rem ${fontFamily.circularBook};
  padding-top: 0.2rem;

  /* background-color: red; */

  /* margin-bottom: 4rem; */
  &.ml {
    margin-left: 1rem;
  }
`;

const ItemContainer = styled.div`
  /* background-color: #f4f4f8; */
  border-radius: 10px;
  /* box-shadow: -5px -5px 11px #fffffff5; */
  margin-bottom: 2rem;
  padding: 1rem;
  width: 100%;
  & .mainDetails {
    font: 1.8rem ${fontFamily.circularMedium};
    color: #4a4a4a;
    margin-bottom: 1rem;
  }
  & .subDetails {
    font: 1.4rem ${fontFamily.circularMedium};
    color: #393939;
  }
`;

const TimelineItem = ({ item }) => {
  const {
    profilePic,
    from_state,
    to_state,
    timestamp,
    transaction_id,
    transition_by
  } = item;
  return (
    <Container>
      <ItemContainer>
        <FlexContainer
          className='jc_spacebetween ai_center'
          style={{ marginBottom: '1rem' }}
        >
          <FlexContainer className='ai_center jc_spacebetween'>
            <FlexContainer
              className='ai_center jc_spacebetween'
              style={{ gap: '1rem' }}
            >
              {!profilePic && (
                <ImageContainer
                  style={{ height: '100%', position: 'relative' }}
                  className='ai_center'
                >
                  <AvatarComponent
                    userdata={{ firstName: transition_by }}
                    circle={true}
                  />
                </ImageContainer>
              )}
              <div>
                <UsernameText>{`${transition_by}`}</UsernameText>
                <Content>
                  {timestamp ? getFormatedTimestamp(timestamp) : '-'}
                </Content>
              </div>
            </FlexContainer>
            {/* <Content className='ml'>{`${to_state}`}</Content> */}
            {/* <Content>
              {to_state.charAt(to_state.length - 1) === 'e' ? 'd' : 'ed'}
            </Content> */}
            {/* <Content className='ml'>work order</Content> */}
            {/* <UsernameText className='ml'>{`${transaction_id}`}</UsernameText> */}
          </FlexContainer>
        </FlexContainer>
        <FlexContainer className='jc_spacebetween ai_end'>
          <div>
            <Content className='ml'>{getStringLocale('work order')}</Content>
            <UsernameText className='ml'>{`${transaction_id}`}</UsernameText>
          </div>
          <FlexContainer>
            <UsernameText className='ml'>{`${to_state}`}</UsernameText>
            <UsernameText>
              {to_state.charAt(to_state.length - 1) === 'e' ? 'd' : 'ed'}
            </UsernameText>
          </FlexContainer>
        </FlexContainer>
      </ItemContainer>
    </Container>
  );
};

export default TimelineItem;
